module.exports = __webpack_public_path__ + "static/media/PC_Workshop_e_Data_DASHBOARD_E_ANALYTICS.67eadebf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/dashboardAnalytics/PC_Workshop_e_Data_DASHBOARD_E_ANALYTICS.png
// module id = 61
// module chunks = 0